/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Nousagedescription2Inputs */

const zh_usage_nousagedescription2 = /** @type {(inputs: Usage_Nousagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当你使用 AI 功能后，用量将会显示在这里。`)
};

const en_usage_nousagedescription2 = /** @type {(inputs: Usage_Nousagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you use AI features, your usage will appear here.`)
};

const es_usage_nousagedescription2 = /** @type {(inputs: Usage_Nousagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vez que uses funciones de IA, tu uso aparecerá aquí.`)
};

/**
* | output |
* | --- |
* | "Once you use AI features, your usage will appear here." |
*
* @param {Usage_Nousagedescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usage_nousagedescription2 = /** @type {((inputs?: Usage_Nousagedescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Nousagedescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_nousagedescription2(inputs)
	if (locale === "en") return en_usage_nousagedescription2(inputs)
	return es_usage_nousagedescription2(inputs)
});
export { usage_nousagedescription2 as "usage_noUsageDescription" }